<template>
  <img
    src="https://cdn-xcx-qunsou.weiyoubot.cn/material/20220511/143372aed4285cba97f6154c4e708f74.svg"
    :class="position === 'left' ? 'homeIcon' : 'homeIconRight'"
    alt=""
    @click="toHome"
  />
</template>
<script>
export default {
  props: {
    position: {
      type: String,
      default: 'left'
    }
  },
  methods: {
    toHome() {
      this.$router.push({ name: "home" });
    }
  }
};
</script>
<style lang="scss" scoped>
@function rem($px) {
  @return $px * 2 / 75 + rem;
}
.homeIcon {
  width: rem(27);
  height: rem(27);
  top: rem(15);
  left: rem(15);
  position: absolute;
  z-index: 99;
  cursor: pointer;
}
.homeIconRight{
  position: absolute;
  width: rem(27);
  height: rem(27);
  top: rem(15);
  right: rem(15);
  z-index: 99;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/homeIcon.vue